import React from 'react'

interface AffiliateIdCellProps {
  affiliate_id: string
}

export const AffiliateIdCell = ({ affiliate_id }: AffiliateIdCellProps) => {
  return <div className='w-56 overflow-hidden text-ellipsis whitespace-nowrap'>{affiliate_id}</div>
}
